<template>
  <form style="min-height: 60vh;">
    <template v-if="disclaimer==false && registered == false">
    <div style="width: 75%; margin: auto; background-color: #8A8D91;" >
        <div style="width: 500px; height: 75px; margin-bottom: 25px; margin-left: auto; margin-right: auto;"><img src="https://mobipest.eu/wp-content/uploads/2021/01/mobipest_logo.png" style="width: 100%; height: 100%;"></div>
        <div  style="width: 500px; margin: auto; margin-top: 25px;"><h5 v-if="alert">{{alert}}</h5></div>
        <div class="row" v-if="token == '' && alert == undefined" style="margin-top: 0.25rem; margin-bottom: 0.25rem; text-align: right;">
            <div class="col s4" style="text-align: right; margin-top: 0.75rem; margin-bottom: 0.25rem;">{{ $t('register.email') }} </div>
            <div class="input-field inline col s4" style="margin-top: 0.25rem; margin-bottom: 0.25rem; "><input v-model="email" v-on:blur="validateEmailField" /></div>
            <div class="col s4" style="text-align: right; margin-top: 0.75rem; margin-bottom: 0.25rem;"><span style="color:#c22026;">{{emailError}}</span></div>
        </div>
        <div class="row" v-if="token == '' && alert == undefined" style="margin-top: 0.25rem; margin-bottom: 0.25rem; text-align: right;">
            <div class="col s4" style="text-align: right; margin-top: 0.75rem; margin-bottom: 0.25rem;">{{$t('register.email_confirm')}} </div>
            <div class="input-field inline col s4" style="margin-top: 0.25rem; margin-bottom: 0.25rem; "><input v-model="email_confirm" v-on:blur="validateEmailField" /></div>
             <div class="col s4" style="text-align: right; margin-top: 0.75rem; margin-bottom: 0.25rem;"><span style="color:#c22026;">{{emailConfirmError}}</span></div>
        </div>
        <h6 v-if="errors.length > 0" style="color: #c22026; text-align: center;line-height: 2;">{{errors}}</h6>
        <div class="row" style="margin-top: 0.25rem; margin-bottom: 0.25rem; text-align: right;" v-if="alert == undefined">
            <div class="col s4" style="text-align: right; margin-top: 0.75rem; margin-bottom: 0.25rem;">{{ $t('register.password') }} </div>
            <div class="input-field inline col s4" style="margin-top: 0.25rem; margin-bottom: 0.25rem; "><input type="password" v-model="password" /></div>
        </div>
        <div class="row" style="margin-top: 0.25rem; margin-bottom: 0.25rem; text-align: right;" v-if="alert == undefined">
            <div class="col s4" style="text-align: right; margin-top: 0.75rem; margin-bottom: 0.25rem;">{{ $t('register.password_confirm') }} </div>
            <div class="input-field inline col s4" style="margin-top: 0.25rem; margin-bottom: 0.25rem; "><input type="password" v-model="password_confirm"  v-on:blur="validatePasswordField"/></div>
            <div class="col s4" style="text-align: right; margin-top: 0.75rem; margin-bottom: 0.25rem;"><span style="color:#c22026;">{{passwordConfirmError}}</span></div>
        </div>
        <div class="row" style="margin-bottom: 0px;" v-if="alert == undefined">
            <div class="col s8 offset-s4" style="margin-bottom: 0px;">
                <div style="width: 500px;"><label>
                        <input type="checkbox" disabled="true" :checked="hasAtLeastDigit()" />
                        <span>{{$t('register.at_least_one_digit')}}</span>
                    </label></div>
                <div style="width: 500px;"><label>
                        <input type="checkbox" disabled="true" :checked="hasAtLeastSpecialChar()" />
                        <span>{{$t('register.at_least_one_special_character')}}</span>
                    </label></div>
                <div style="width: 500px;"><label>
                        <input type="checkbox" disabled="true" :checked="hasAtLeastOneUpperAndLower()" />
                        <span>{{$t('register.at_least_one_uppercase_one_lowercase')}}</span>
                    </label></div>
                <div style="width: 500px;"><label>
                        <input type="checkbox" disabled="true"  :checked="hasAtLeastEightChars()" />
                        <span>{{$t('register.at_least_eight_characters')}}</span>
                    </label></div>
            </div>
        </div>
    </div>
    <div style="padding-left: 35%; padding-top: 15px; padding-bottom: 5px;"  v-if="alert == undefined"><label>
            <input type="checkbox" v-model="data_agreement"/>
            <span> <span style="color:#c22026;">({{$t('register.required')}})</span> {{$t('register.rules_consent')}}</span>
        </label></div>
    <div style="padding-left: 35%;padding-bottom: 5px;"  v-if="alert == undefined"><label>
            <input type="checkbox" v-model="anonymous_stats"/>
            <span> {{$t('register.anonymous_stats')}} </span>
        </label></div>
    <div style="padding-left: 35%;padding-bottom: 5px;"  v-if="alert == undefined"><label>
            <input type="checkbox" v-model="newsletter"/>
            <span> {{$t('register.newsletter')}} </span>
        </label></div>
    <div style="padding-left: 35%;padding-bottom: 5px;"  v-if="alert == undefined"><label>
            <input type="checkbox" v-model="offers"/>
            <span> {{$t('register.marketing')}}</span>
        </label></div>
        
    </template>

     <template v-if="disclaimer && registered == false && emailError.length == 0">
        <div style="width: 75%; margin: auto; background-color: #8A8D91;">
        <div style="width: 500px; height: 75px; margin-bottom: 25px; margin-left: auto; margin-right: auto;"><img src="https://mobipest.eu/wp-content/uploads/2021/01/mobipest_logo.png" style="width: 100%; height: 100%;"></div>
        <h5 style="text-align: center;"  v-html="$t('menu.you_will_register')"></h5>
        <p><b v-html="$t('menu.dont_register_ifnotcustomer')"></b></p>
        <p>{{$t('menu.request_for_account_to_ddd')}}</p>
    </div>
    </template>
     <template v-if="disclaimer && registered == false && emailError.length > 0">
        <div style="width: 75%; margin: auto; background-color: #8A8D91;">
        <div style="width: 500px; height: 75px; margin-bottom: 25px; margin-left: auto; margin-right: auto;"><img src="https://mobipest.eu/wp-content/uploads/2021/01/mobipest_logo.png" style="width: 100%; height: 100%;"></div>
        <h5 style="text-align: center;">{{$t('menu.email_registered')}}</h5>
    </div>
    </template>
    <template v-if="disclaimer == false && registered">
        <div style="width: 75%; margin: auto; background-color: #8A8D91;">
        <div style="width: 500px; height: 75px; margin-bottom: 25px; margin-left: auto; margin-right: auto;"><img src="https://mobipest.eu/wp-content/uploads/2021/01/mobipest_logo.png" style="width: 100%; height: 100%;"></div>
        <p>{{$t('menu.we_sent_activation_link')}}</p>
        <p>{{email}}</p>
        <p>{{$t('menu.check_inbox')}}</p>
    </div>
    </template>

    <template  v-if="!registered && (!disclaimer || emailError.length == 0) && alert == undefined">
        <div class="row">
            <div class="col offset-s4 s4" v-append="recaptcha"></div>
            <div class="col s4" v-if="nocaptchaError">
                <span style="color:#c22026;">{{$t('menu.check_not_robot')}}</span>
            </div>
        </div>
    <div class="row" style="margin-bottom: 0px;" v-if="alert == undefined">
        <div class="col offset-s4 s4" style="margin-top: 0.75rem; margin-bottom: 0.75rem; text-align: center;">
            <button v-on:click.prevent="register_sent()" class="waves-effect waves-light btn-large red" style="text-transform: initial;" :disabled="isRegisterFormValid() == false">{{$t('register.register')}}</button></div>
    </div>
    <div class="col offset-s4 s4" style="text-align: center;" v-if="alert == undefined">
        <a  href="/pages/index" class="waves-effect waves-light btn-large" style="margin-top: 0.25rem; margin-bottom: 0.25rem; text-transform: initial;">
            {{$t('register.cancel')}}
        </a>
    </div>
    </template>
    <template  v-if="registered || (disclaimer && emailError.length > 0)">
    <div class="col offset-s4 s4" style="text-align: center;">
        <a href="#/login" class="waves-effect waves-light btn-large" style="margin-top: 0.25rem; margin-bottom: 0.25rem; text-transform: initial;">
            {{$t('login.login')}}
        </a>
    </div>
    <div class="col offset-s4 s4" style="text-align: center;">
        <a  v-on:click="reset()" class="waves-effect waves-light btn-large" style="margin-top: 0.25rem; margin-bottom: 0.25rem; text-transform: initial;">
            {{$t('login.forgot_password')}}
        </a>
    </div>
    </template>
</form>
</template>

<script>
import axios from 'axios';
export default {
		 data: function() {
	        return {
	            email: "",
                emailError: "",
	            password: "",
	            email_confirm: "",
                emailConfirmError: "",
	            password_confirm: "",
                passwordConfirmError: "",
                data_agreement: false,
                registering: false,
                registered: false,
                offers: false,
                newsletter: false,
                recaptcha: "",
                invitation_token: '',
                anonymous_stats: false,
                disclaimer: false,
                nocaptchaError: false,
                errors: ""
	        }
    	},
        props: {
            token: {
                default: ''
            },
            alert: String
        },
        mounted: function(){
            axios.get('/users/sign_up.json').then(response => {
                this.recaptcha = response.data.tags.slice(75, response.data.tags.length - 75);
                let recaptchaScript = document.createElement('script')
                recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js')
                document.head.appendChild(recaptchaScript)
            })
        },
        created: function(){
        },
        methods: {
        	hasAtLeastDigit: function() {
            return /\d/.test(this.password);
        },
        hasAtLeastSpecialChar: function() {
            return /[!@#$%^&*.?]/.test(this.password);
        },
        hasAtLeastOneUpperAndLower: function() {
            return /[A-Z]/.test(this.password) && /[a-z]/.test(this.password)
        },
        hasAtLeastEightChars: function() {
            return this.password.length >= 8;
        },
        emailIsValid: function(email) {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
        },
        validateEmailField: function(){
            if(this.email.length == 0){
                this.emailError = "Pole nie może być puste"
            }else if(this.emailIsValid(this.email) == false){
                this.emailError = "Nieprawidłowy adres email"
            }else{
                this.emailError = ""
            }
        },
        validateEmailField: function(){
            if(this.email != this.email_confirm){
                this.emailConfirmError = "Adresy email nie są identyczne"
            }else{
                this.emailConfirmError = ""
            }
        },
        validatePasswordField: function(){
            if(this.password != this.password_confirm){
                this.passwordConfirmError = "Podane hasła nie są identyczne"
            }else{
                this.passwordConfirmError = ""
            }
        },
        isRegisterFormValid() {
            if(this.token == ''){
                return this.email.length > 0 && this.emailIsValid(this.email) && this.email == this.email_confirm && this.password == this.password_confirm && this.hasAtLeastDigit() && this.hasAtLeastSpecialChar() && this.hasAtLeastOneUpperAndLower() && this.hasAtLeastEightChars() && this.data_agreement
            }else{
                return this.password == this.password_confirm && this.hasAtLeastDigit() && this.hasAtLeastSpecialChar() && this.hasAtLeastOneUpperAndLower() && this.hasAtLeastEightChars() && this.data_agreement
            }
            
        },
        reset(){
            this.$emit('cancel');
            this.$emit('reset');
        },
        cancel(){
            this.$emit('cancel');
        },
        register_sent(){
            var that = this;
            if(this.token == ''){
                if(this.disclaimer){    
                    this.registering = true;
                    axios.post('/users.json', {
                        "company": {
                            "name": "", 
                            "email": this.email,
                            "data_agreement": this.data_agreement,
                            "workers_attributes": [
                            {
                                "user_admin_attributes": {
                                    "email": this.email, "password": this.password,
                                    "email_confirmation": this.email_confirm, "password_confirmation": this.password_confirm, "clause": "1"
                                }
                            }
                            ] }, "g-recaptcha-response": grecaptcha.getResponse()

                    }).then(response => {
                            this.registering = false;
                            this.registered = true;
                            this.disclaimer = false;
                    }).catch(function(reason) {
                       that.registering = false;
                       if(_.isUndefined(reason.response.data['errors']) == false){
                            that.nocaptchaError = true;
                       }else if(_.isUndefined(reason.response.data['workers.user_admin.email']) == false) {
                            that.emailError = _.first(reason.response.data['workers.user_admin.email']);
                        }
                    });
                }else{
                    this.disclaimer = true;
                }
            }else{
                that.errors = "";
                axios.put('/users/invitation.json', {
                    user: {
                        invitation_token: this.token,
                        password: this.password,
                        password_confirmation: this.password_confirm,
                        data_agreement: this.data_agreement
                    }
                }).then(response => {
                    this.registering = false;
                    this.registered = true;
                    this.disclaimer = false;
                    window.location.href = '/pages/index'
                }).catch(function(reason) {
                   that.registering = false;
                   if(_.isUndefined(reason.response.data['errors']) == false){
                        that.nocaptchaError = true;
                   }else if(_.isUndefined(reason.response.data['workers.user_admin.email']) == false) {
                        that.emailError = _.first(reason.response.data['workers.user_admin.email']);
                    }
                    that.errors = _.join(_.values(reason.response.data))
                });
            }
        }
    },
}
</script>

<style scoped>
.login_button {
    color: red;
}

p {
    font-size: 1em;
    text-align: center;
}

nav {
    background-color: #8A8D91;
    height: 100px;
}

img {
    width: 50px;
    height: 50px;
}

nav a {
    margin: 15px;
    font-size: 18px;
}

nav i {
    font-size: initial;
    height: initial;
    line-height: initial;
    padding-top: 6px;
}

nav li.menuitems {
    text-transform: uppercase;
    width: 130px;
    text-align: center !important;
    margin-top: 16px;
    background-color: #BEBBBB;
    height: 84px;
}

nav ul li {
    margin-top: 14px;
}

li.menuitems a {
    color: black !important;
    margin: 0px;
    padding: 0px;
    height: 84px;
    line-height: 1.5;
}

.menuitems i.material-icons {
    font-size: 48px !important;
}

nav li.selected {
    background-color: #C22026;
    height: 84px;

}

.btn-large,
.btn {
    border-radius: 8px !important;
    color: black;
}

.nav-wrapper {
    color: black !important;
}

.logout {
    background-color: #C22026 !important;
}

.upmenu {
    width: 1170px;
    position: absolute;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    text-align: center;
    letter-spacing: 2.5px;
}

form .btn-large {
    width: 338px;
}

.grayed {
    background-color: rgb(138, 141, 145);
}

.page-footer {
    background-color: rgb(218, 218, 218);
    color: black !important;
}

.page-footer h6 {
    font-weight: bold;
}

.page-footer p {
    text-align: left;
}

label {
    color: black;
}

i.material-icons {
    font-size: 16px !important;
}

.input-field.inline input {
    margin-bottom: initial;
}
.btn-large .preloader-wrapper {
    margin-top: 10px !important;
}
.btn-large{
    background-color: #DADADA;
}
.btn-large:disabled{
    background-color: #DADADA !important;
}
/deep/ .g-recaptcha div{
    margin: auto !important;
}
</style>
